export const RETURN_TO_KEY = "antecipe.returnTo";

export const isSafeReturnTo = (path) =>
  typeof path === "string" &&
  path.startsWith("/admin/") &&
  !path.startsWith("//") &&
  !path.includes("://") &&
  !path.includes("\\");

export const saveReturnTo = (path) => {
  if (!isSafeReturnTo(path)) return;
  try {
    window.sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch (e) {
    // storage bloqueado: depois do login a pessoa cai na home, sem quebrar
  }
};

export const readReturnTo = () => {
  try {
    const value = window.sessionStorage.getItem(RETURN_TO_KEY);
    return isSafeReturnTo(value) ? value : null;
  } catch (e) {
    return null;
  }
};

export const clearReturnTo = () => {
  try {
    window.sessionStorage.removeItem(RETURN_TO_KEY);
  } catch (e) {
    // idem
  }
};
